/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl, checkIsActive } from '../../../../_helpers';
import { useSelector, shallowEqual } from 'react-redux';
import { OverviewLinks } from './OverviewLinks'
import { ReactComponent as Arrow } from '../../../../../../src/app/assets/chevron-right-solid.svg';

export function AsideMenuList({ layoutProps }) {
	const location = useLocation();
	const [customizationDropDown, setCustomizationDropDown] = useState(false);
	const getMenuItemActive = (...urls) => {
		return checkIsActive(location, ...urls) ? ' menu-item-active menu-item-open ' : '';
	};
	const user = useSelector(state => state.auth.user, shallowEqual);
	const merchant = useSelector(state => state.merchants.merchants, shallowEqual)[0];

	return (
		<>
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				{user.profile === 'admin' ? (
					<div className={`menu-nav ${layoutProps.ulClasses}`} style={{ padding: '0 0' }}>
						{user.merchantId === 'all' ?
							<OverviewLinks layoutProps={layoutProps} />
							:
							<li className={`menu-item ${getMenuItemActive('/overview')}`} aria-haspopup='true'>
								<NavLink className='menu-link' to='/overview'>
									<span className='svg-icon menu-icon'>
										<SVG src={toAbsoluteUrl('/assets/Dashboard.svg')} />
									</span>
									<span className='menu-text'>Overview</span>
								</NavLink>
							</li>
						}
						<li className={`menu-item ${getMenuItemActive('/users')}`} aria-haspopup='true'>
							<NavLink className='menu-link' to='/users'>
								<span className='svg-icon menu-icon'>
									<SVG src={toAbsoluteUrl('/assets/users.svg')} />
								</span>
								<span className='menu-text'>Users</span>
							</NavLink>
						</li>

						<li className={`menu-item ${getMenuItemActive('/posts')}`} aria-haspopup='true'>
							<NavLink className='menu-link' to='/posts'>
								<span className='svg-icon menu-icon'>
									<SVG src={toAbsoluteUrl('/assets/posts.svg')} />
								</span>
								<span className='menu-text'>Posts</span>
							</NavLink>
						</li>
						<li className={`menu-item ${getMenuItemActive('/social-media')}`} aria-haspopup='true'>
							<NavLink className='menu-link' to='/social-media'>
								<span className='svg-icon menu-icon'>
									<SVG src={toAbsoluteUrl('/media/svg/icons/Code/Puzzle.svg')} />
								</span>
								<span className='menu-text'>Social Media</span>
							</NavLink>
						</li>
						<li className={`menu-item ${getMenuItemActive('/quizzes')}`} aria-haspopup='true'>
							<NavLink className='menu-link' to='/quizzes'>
								<span className='svg-icon menu-icon'>
									<SVG src={toAbsoluteUrl('/media/svg/icons/Cooking/Dishes.svg')} />
								</span>
								<span className='menu-text'>Quizzes</span>
							</NavLink>
						</li>
						{user.experimental ?
							<>
								<li className={`menu-item ${getMenuItemActive('/ambassador')}`} aria-haspopup='true'>
									<NavLink className='menu-link' to='/ambassador'>
										<span className='svg-icon menu-icon'>
											<SVG src={toAbsoluteUrl('/media/svg/icons/General/Star.svg')} />
										</span>
										<span className='menu-text'>Ambassador</span>
										<span style={{ color: 'yellow' }}>(Experimental)</span>
									</NavLink>
								</li>
							</>
							: null
						}
						<li className={`menu-item ${getMenuItemActive('/fun-facts')}`} aria-haspopup='true'>
							<NavLink className='menu-link' to='/fun-facts'>
								<span className='svg-icon menu-icon'>
									<SVG src={toAbsoluteUrl('/media/svg/icons/General/Fire.svg')} />
								</span>
								<span className='menu-text'>Fun Facts</span>
							</NavLink>
						</li>
					</div>
				) : null}

				<li className={`menu-item ${getMenuItemActive('/moderation')}`} aria-haspopup='true'>
					<NavLink className='menu-link' to='/moderation'>
						<span className='svg-icon menu-icon'>
							<SVG src={toAbsoluteUrl('/media/svg/icons/Design/Component.svg')} />
						</span>
						<span className='menu-text'>Moderation</span>
					</NavLink>
				</li>

				<li className={`menu-item ${getMenuItemActive('/feed')}`} aria-haspopup='true'>
					<NavLink className='menu-link' to='/feed'>
						<span className='svg-icon menu-icon'>
							<SVG src={toAbsoluteUrl('/media/svg/icons/Shopping/Box1.svg')} />
						</span>
						<span className='menu-text'>Feed</span>
					</NavLink>
				</li>
				{/* <li className={`menu-item ${getMenuItemActive('/overview')}`} aria-haspopup='true'>
					<NavLink className='menu-link' to='/overview'>
						<span className='svg-icon menu-icon'>
							<SVG src={toAbsoluteUrl('/assets/Dashboard.svg')} />
						</span>
						<span className='menu-text'>Plans</span>
					</NavLink>
				</li> */}
				{merchant && merchant.shopify ? (

					<li className={`menu-item ${getMenuItemActive('/help')}`} aria-haspopup='true'>
						<NavLink className='menu-link' to='/help'>
							<span className='svg-icon menu-icon'>
								<SVG src={toAbsoluteUrl('/assets/Dashboard.svg')} />
							</span>
							<span className='menu-text'>Shopify Activation</span>
						</NavLink>
					</li>
				) : null}
				{merchant && merchant.options ? (
					<li
						className={`menu-item ${getMenuItemActive(
							'/visibility',
							'/welcome',
							'/wishlist',
							'/customer-support',
						)}`}
						aria-haspopup='true'
					>
						<div
							className={`menu-link ${customizationDropDown ? 'menu-show' : ''}`}
							onClick={() => setCustomizationDropDown(!customizationDropDown)}
						>
							<span className='svg-icon menu-icon svg-icon-1'>
								<SVG src={toAbsoluteUrl('/media/svg/icons/Design/Component.svg')} />
							</span>
							<span className='menu-text'>Customization</span>
							<span>
								<Arrow className='arrow-icon' />
							</span>
						</div>
						<div className={`js-dropdown-list ${customizationDropDown ? 'js-show' : 'js-hide'}`}>
							<ul>
								<li
									className={`menu-item ${getMenuItemActive('/visibility')}`}
									aria-haspopup='true'
								>
									<NavLink className='menu-link' to='/visibility'>
										<span className='menu-bullet'>
											<span className='bullet bullet-dot'></span>
										</span>
										<span className='menu-text'>Visibility</span>
									</NavLink>
								</li>
								<li className={`menu-item ${getMenuItemActive('/welcome')}`} aria-haspopup='true'>
									<NavLink className='menu-link' to='/welcome'>
										<span className='menu-bullet'>
											<span className='bullet bullet-dot'></span>
										</span>
										<span className='menu-text'>Welcome</span>
									</NavLink>
								</li>
								<li className={`menu-item ${getMenuItemActive('/wishlist')}`} aria-haspopup='true'>
									<NavLink className='menu-link' to='/wishlist'>
										<span className='menu-bullet'>
											<span className='bullet bullet-dot'></span>
										</span>
										<span className='menu-text'>Wishlist</span>
									</NavLink>
								</li>
								<li
									className={`menu-item ${getMenuItemActive('/customer-support')}`}
									aria-haspopup='true'
								>
									<NavLink className='menu-link' to='/customer-support'>
										<span className='menu-bullet'>
											<span className='bullet bullet-dot'></span>
										</span>
										<span className='menu-text'>Customer Support</span>
									</NavLink>
								</li>
							</ul>
						</div>
					</li>
				) : null}
				{user.profile === 'admin' ? (
					<div className={`menu-nav ${layoutProps.ulClasses}`} style={{ padding: '0 0' }}>
						<li className={`menu-item ${getMenuItemActive('/challenges')}`} aria-haspopup='true'>
							<NavLink className='menu-link' to='/challenges'>
								<span className='svg-icon menu-icon'>
									<SVG src={toAbsoluteUrl('/media/svg/icons/Code/Compiling.svg')} />
								</span>
								<span className='menu-text'>Challenges</span>
							</NavLink>
						</li>
						<li className={`menu-item ${getMenuItemActive('/story')}`} aria-haspopup='true'>
							<NavLink className='menu-link' to='/story'>
								<span className='svg-icon menu-icon'>
									<SVG src={toAbsoluteUrl('/media/svg/icons/Code/Thunder-circle.svg')} />
								</span>
								<span className='menu-text'>Story</span>
							</NavLink>
						</li>
					</div>
				) : null}
			</ul>
		</>
	);
}
